import { AgeGroup, Game } from "@aura-frontend/omnibus-az-client";
import { Dialog, Label, Select } from "@win-reality/react-ui";
import { useEffect, useState } from "react";

import { ageGroupOptions } from "@/types/game";

import { useGenerateReport } from "../hooks/useGenerateReport";

type GenerateReportModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  game: Game | null;
  onSuccess?: (gameUuid: string) => void;
};

export function GenerateReportModal({
  open,
  onOpenChange,
  game,
  onSuccess,
}: GenerateReportModalProps) {
  const [ageGroup, setAgeGroup] = useState<AgeGroup | undefined>();
  const { generateReport, generatingReportGameIds } = useGenerateReport();

  useEffect(() => {
    if (open) setAgeGroup(undefined);
  }, [open]);

  const handleSubmit = async () => {
    if (!game || !ageGroup) return;
    const success = await generateReport(game, ageGroup);
    if (success) {
      if (game.gameUuid) {
        onSuccess?.(game.gameUuid);
      }
      onOpenChange(false);
    }
  };

  const isGenerating = !!(
    game?.gameUuid && generatingReportGameIds.has(game.gameUuid)
  );

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title="Generate Report"
      description="We didn't find an age group specified on this game. Select an age group for comparison metrics in the report."
      size="md"
      primaryAction={{
        label: "Generate Report",
        onClick: handleSubmit,
        isLoading: isGenerating,
        isDisabled: !ageGroup,
      }}
    >
      <div className="flex flex-col gap-2">
        <Label className="text-sm">Age Group</Label>
        <Select
          items={ageGroupOptions}
          value={ageGroup}
          onValueChange={setAgeGroup}
          placeholder="Select age group"
        />
      </div>
    </Dialog>
  );
}
